import React from 'react';

import { Box, Typography } from '@mui/material';

interface Props {
  label: string;
  children: React.ReactNode;
}

export default function ProseValuePanel({ label, children }: Props) {
  return (
    <Box
      sx={{
        bgcolor: 'grey.50',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        p: 1.5,
      }}
    >
      <Typography variant="caption" color="text.secondary" fontWeight={700}>
        {label}
      </Typography>
      <Box
        sx={{
          mt: 0.75,
          '& .MuiTypography-body2': {
            lineHeight: 1.55,
            whiteSpace: 'pre-wrap',
          },
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
